import * as React from "react";
import * as ReactDOM from "react-dom";
import { CardTabs } from "./components/CardTabs";
import { CardHeader } from "./components/CardHeader";
import { CardFooter } from "./components/CardFooter";
import { CardContent } from "./components/CardContent";
import classnames from "classnames";
import * as styles from "./styles.scss";

export interface ITab {
  tab: any;
  id: string;
  url?: string;
}

export interface IProps {
  tabList?: typeTabList;
  defaultActiveTab?: string;
  header?: any;
  footer?: any;
  noMargin?: boolean;
  tabPosition?: "top" | "bottom" | "header";
  onChangeTab?: any;
  cssModifier?: string;
}

export type typeTabList = ITab[];

export class Card extends React.Component<IProps, {}> {
  public render() {
    const {
      tabList,
      children,
      defaultActiveTab,
      header,
      footer,
      noMargin,
      onChangeTab,
      tabPosition = "top"
    } = this.props;

    const tabs = !tabList || (
      <CardTabs
        tabs={tabList}
        onChangeTab={onChangeTab}
        defaultActiveTab={defaultActiveTab}
      />
    );
    const isTabsTop = tabPosition === "top" && tabList;
    const isTabsBot = tabPosition === "bottom" && tabList;
    const isTabsHeader = tabPosition === "header" && tabList;

    const className = classnames({
      [styles.card]: true,
      "block block_panel": !this.props.noMargin,
      [this.props.cssModifier]: !!this.props.cssModifier
    });

    return (
      <>
        {isTabsTop ? tabs : false}
        {!header || <CardHeader>{header}</CardHeader>}
        {isTabsHeader ? <CardHeader>{tabs}</CardHeader> : false}
        <div className={className}>
          {isTabsBot ? tabs : false}
          <CardContent noMargin={this.props.noMargin}>{children}</CardContent>
          {!footer || <CardFooter>{footer}</CardFooter>}
        </div>
      </>
    );
  }
}
